import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { transitionDefault } from '../../../utils/styles';
import { FONT_SIZE_TEXT } from '../../../constants/index';
import LinkFade from '../../LinkFade';
import { inject, observer } from 'mobx-react/index';
import mq from '@/utils/media-queries';

const Styled = styled(LinkFade)`
  display: block;
  user-select: none;
  color: ${props => props.theme.colorText};
  text-decoration: none;
  font-size: ${FONT_SIZE_TEXT}px;
  ${transitionDefault};

  ${mq.mobile375(css`
    font-size: 16px;
  `)};
`;

const Logo = ({ className, text, path }) => (
  <Styled className={className} to={path}>
    {text}
  </Styled>
);

Logo.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default inject(stores => ({
  logoStore: stores.store.logoStore,
}))(observer(({ logoStore, ...rest }) => <Logo {...rest} text={logoStore.text} path={logoStore.path} />));



// WEBPACK FOOTER //
// ./src/components/Header/components/Logotype.js